import { ColProps } from 'antd';
import { ReactNode } from 'react';
import {
  LabelPrintingLayoutPreset,
  LabelPrintingLayoutPresetKey,
} from './Toolbar/presets';

export enum LabelPrintingLayoutOrientation {
  landscape = 'landscape',
  portrait = 'portrait',
}

export enum LabelPrintingLayoutAlign {
  left = 'left',
  center = 'center',
  right = 'right',
}

export enum LabelPrintingLayoutVerticalAlign {
  start = 'flex-start',
  center = 'center',
  end = 'flex-end',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface LabelPrintingFormValues<T = any> {
  preset: LabelPrintingLayoutPresetKey;
  layout?: LabelPrintingLayoutPreset;
  item: T;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface LabelPrintingRenderCardContentParams<T = any>
  extends LabelPrintingFormValues<T> {
  node: HTMLElement | null;
}

export interface LabelPrintingCustomOption {
  component: ReactNode;
  colProps?: ColProps;
}
